export const getFilterIsOpen = (store, filterId) => {
	const { filterIsOpen } = store;
	return typeof filterIsOpen[filterId] !== 'undefined' ? filterIsOpen[filterId] : false;
};

export const getFilterLanguage = (store, filterId) => {
	const { currentLanguage } = store;
	return typeof currentLanguage[filterId] !== 'undefined' ? currentLanguage[filterId] : false;
};

export const getOpenCategories = (store, filterId) => {
	const { openCategories } = store;
	return typeof openCategories[filterId] !== 'undefined' ? openCategories[filterId] : [];
};

export const getSelectedCategories = (store, filterId) => {
	const { selectedCategories } = store;
	return typeof selectedCategories[filterId] !== 'undefined' ? selectedCategories[filterId] : [];
};

export const getSelectedTopics = (store, filterId) => {
	const { selectedTopics } = store;
	return typeof selectedTopics[filterId] !== 'undefined' ? selectedTopics[filterId] : [];
};
